interface Props {
  error: Error
  resetErrorBoundary: () => void
}

export const ErrorPage: React.FC<Props> = ({
  error,
  // resetErrorBoundary: handleErrorResetting
}) => <>Something went wrong: {error.message}</>
